var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.copy,on:{"click":_vm.handleClick}},[_vm._t("default",function(){return [_vm._v("复制")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }